import './index.less'

const PersonalInformationList = () => {
  return (
    <div className="word-file">
    <p>1.为保障应用相关功能的实现与应用安全稳定的运行，我们可能会接入由合作方提供的软件开发包(SDK)、应用程序接口(API)、应用程序插件等代码或通过其他合作方式，以实现相关目的。</p>
    <p>2.我们会对获取信息的合作方的代码进行严格的安全监测，以保证数据安全。</p>
    <p>3.我们对接入的相关合作方在目录中列明，合作方具体的处理情况请参见合作方的隐私政策或服务协议。</p>
    <p>4.请注意，合作方的代码可能因为其版本升级，策略调整等原因导致数据处理类型存在一定变化，请以其公示的官方说明为准。</p>

    <h6>第三方SDK目录</h6>

    <div className="custom-table">
      <p>
        <span>第三方sdk名称</span>
        <span>所属公司</span>
        <span>收集信息</span>
        <span>使用目的</span>
        <span>隐私链接</span>
      </p>
      <p>
        <span>高德定位SDK</span>
        <span>高德软件有限公司</span>
        <span>
          位置信息(经纬度、精确位置、粗略位置)【通过IP 地址、GNSS信息、WiFi状态、WiFi参数、WiFi列表、SSID、BSSID、基站信息、信号强度的信息、蓝牙信息、传感器信息(矢量、加速度、压力)、设备信号强度信息获取、外部储存目录】、设备标识信息(IMEI、IDFA、IDFV.Android ID、MEID、MAC地址、OAID、IMSI、ICCID、硬件序列号)、当前应用信息(应用名、应用版本号)、设备参数及系统信息(系统属性、设备型号、操作系统、运营商信息)、读取特定类型传感器列表
        </span>
        <span>用于用户位置服务(发布信息的位置定位);在软件处于后台状态，高德定位SDK会收集你的个人信息用于持续定位</span>
        <span>
          <a href="https://lbs.amap.com/pages/privacy/">https://lbs.amap.com/pages/privacy/</a>
        </span>
      </p>
      <p>
        <span>高德地图SDK</span>
        <span>高德软件有限公司</span>
        <span>
          位置信息(经纬度、精确位置、粗略位置)【通过IP 地址、GNSS信息、WiFi状态、WiFi参数、WiFi列表、SSID、BSSID、基站信息、信号强度的信息、蓝牙信息、传感器信息(矢量、加速度、压力)、设备信号强度信息获取、外部储存目录】、设备标识信息(IMEI、IDFA、IDFV.Android ID、MEID、MAC地址、OAID、IMSI、ICCID、硬件序列号)、当前应用信息(应用名、应用版本号)、设备参数及系统信息(系统属性、设备型号、操作系统、运营商信息)、读取特定类型传感器列表
        </span>
        <span>用于在地图上显示用户当前位置以及附近的poi建筑</span>
        <span>
          <a href="https://lbs.amap.com/pages/privacy/">https://lbs.amap.com/pages/privacy/</a>
        </span>
      </p>
      <p>
        <span>高德导航SDK</span>
        <span>高德软件有限公司</span>
        <span>
        位置信息(经纬度、精确位置、粗略位置)【通过IP 地址、GNSS信息、WiFi状态、WiFi参数、WiFi列表、SSID、BSSID、基站信息、信号强度的信息、蓝牙信息、传感器信息(矢量、加速度、压力)、设备信号强度信息获取、外部储存目录】、设备标识信息(IMEI、IDFA、IDFV.Android ID、MEID、MAC地址、OAID、IMSI、ICCID、硬件序列号)、当前应用信息(应用名、应用版本号)、设备参数及系统信息(系统属性、设备型号、操作系统、运营商信息)、读取特定类型传感器列表
        </span>
        <span>用于在地图上显示用户当前位置以及附近的poi建筑</span>
        <span>
          <a href="https://lbs.amap.com/pages/privacy/">https://lbs.amap.com/pages/privacy/</a>
        </span>
      </p>
      <p>
        <span>腾讯云通信SDK</span>
        <span>深圳市腾讯计算机系统有限公司</span>
        <span>设备信息(如设备型号、操作系统版本、唯一设备标识符（如Android ID、OAID）、设备序列号（SN）、设备MAC地址、IP地址、无线网络信息、传感器信息、屏幕分辨率、CPU信息)</span>
        <span>识别用户身份，保障账号安全。适配不同设备，确保SDK兼容性和正常运行。用于问题排查和数据分析（如崩溃分析）</span>
        <span>
          <a href="https://cloud.tencent.com/document/product/301/34003">https://cloud.tencent.com/document/product/301/34003</a>
        </span>
      </p>
    </div>
  </div>
  )
}

export default PersonalInformationList